<template>
  <div class="page-container">
    <NavBar :data="navbarData" />
    <div class="page-content-wrapper">
      <div class="login-container flex">
        <div class="login-pic-wrap">
          <div class="login-pic-container flex">
            <img src="../assets/image/cl_login_pic.png" alt="" />
            <div class="product-name-wrapper">
              <p class="name-zh">传联</p>
              <p class="name-en">HANDLIAN</p>
            </div>
          </div>
          <div class="motto-wrap">传播正能量 联袂万古亲</div>
        </div>
        <div class="login-module-wrap">
          <LoginForm />
        </div>
      </div>
    </div>
    <div class="off-line-wrap">
      <el-dialog
        title="退出登录提示"
        :visible.sync="offLineDialog"
        custom-class="handlian-report-container"
        width="360px"
      >
        <div class="off-line-container">
          <div class="off-line-tip">
            <p>您的帐号已经通过手机端强制退出</p>
            <p>
              若非自己操作，请立即<a
                href="/forget"
                target="_blank"
                class="change-psw-btn"
                >修改密码</a
              >
            </p>
            <p>以确保帐号安全！</p>
          </div>
          <div class="off-line-btn">
            <el-button
              class="handlian-btn"
              type="primary"
              @click="offLineDialog = false"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <Footer />
    <ScrollTop />
  </div>
</template>
<script>
import InputGroup from "../components/InputGroup";
import SubButton from "../components/SubButton";
import { apiMap } from "../utils/apiMap";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import ScrollTop from "../components/scrollTop";
import LoginForm from "../components/LoginForm";
export default {
  name: "login",
  components: {
    InputGroup,
    SubButton,
    NavBar,
    Footer,
    ScrollTop,
    LoginForm,
  },
  data() {
    return {
      user: {
        account: "",
        password: "",
      },
      navbarData: [
        { title: "首页", path: "/" },
        { title: "社区", path: "/square" },
        { title: "关于", path: "/about" },
        { title: "登录", path: "/login" },
      ],
      offLineDialog: false,
    };
  },
  computed: {
    isDisabled() {
      if (this.user.account && this.user.password) return false;
      else return true;
    },
  },
  mounted() {
    this.checkeoutOffLine();
  },
  methods: {
    //登录方法已废弃
    loginClick() {
      var emailReg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      var numberReg = /^[0-9]+$/;
      if (!numberReg.test(this.user.account)) {
        alert("请输入合法的帐号！");
        return;
      }
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["login"]["method"],
        url: apiMap["login"]["url"],
        data:
          "account=" + this.user.account + "&password=" + this.user.password,
      })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            let loginInfo = response.data.result.data;
            // const token = $this.user.password;
            // localStorage.setItem("wxpyqToken", token);

            // 解析token headImgUrl
            // const decode = jwt_decode(token);
            // 存储数据
            if (!loginInfo.thumbHeadImg) {
              loginInfo.avatar = Store.state.defaultAvatar.C2C;
            } else {
              loginInfo.avatar = loginInfo.thumbHeadImg;
            }
            sessionStorage.setItem("userInfo", JSON.stringify(loginInfo));
            Store.dispatch("setUser", loginInfo);
            // 页面跳转
            Router.push("/home");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setContactMap(friendList) {
      if (Array.isArray(friendList)) {
        let friendsMap = {};
        friendList.forEach((item) => {
          var key = item.userId.toString();
          var remark = "";
          var displayHeadImg = this.$store.state.defaultAvatar.C2C;
          if (item.thumbHeadImg) {
            displayHeadImg = item.thumbHeadImg;
          } else if (item.headImgUrl) {
            displayHeadImg = item.headImgUrl;
          }
          if (item.markInfo) {
            remark = item.markInfo.mark;
          }
          friendsMap[key] = {
            imId: item.userId,
            handNum: item.handNum,
            name: item.name,
            image: displayHeadImg,
            group: item.group,
            isBind: item.relation.isBind,
            relation: item.relation.name,
            markInfo: item.markInfo,
            remark: remark,
          };
        });
        this.$store.dispatch("setContactMap", friendsMap);
      }
    },
    checkeoutOffLine() {
      const isLogout = sessionStorage.LOGOUT ? true : false;
      if (isLogout) {
        this.offLineDialog = true;
        tim.logout();
        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        this.$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["logout"]["method"],
          url: apiMap["logout"]["url"],
          data: `token=${loginUser.token}`,
        })
          .then(function(response) {})
          .catch(function(error) {
            console.log(error);
          });
        this.$store.dispatch("resetConversationList");
        this.$store.dispatch("setContactBook");
        sessionStorage.clear();
        localStorage.clear();
      }
    },
  },
};
</script>
<style scoped>
.page-container .header-wrapper {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
  border-bottom: solid 1px #e6e6e6;
}

.page-content-wrapper {
  width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  padding-top: 61px;
}

.login-container {
  width: 900px;
  margin: 207px auto;
  justify-content: space-between;
}

.login-pic-wrap {
  width: 500px;
  height: 396px;
  color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../assets/image/cl_login_bg_1.png");
  border-radius: 5px;
}

.login-pic-container {
  margin-top: 70px;
  margin-bottom: 150px;
  justify-content: center;
}

.product-name-wrapper {
  display: flex;
  margin-left: 28px;
  flex-direction: column;
  justify-content: center;
}

.motto-wrap {
  width: 345px;
  height: 29px;
  margin: 20px auto;
  font-size: 30px;
  font-weight: 500;
  word-spacing: 30px;
  line-height: 25px;
}

.name-zh {
  width: 129px;
  height: 46px;
  font-size: 46px;
  font-weight: 500;
  line-height: 40px;
  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines;
}

.name-en {
  width: 130px;
  height: 18px;
  margin-top: 17px;
  margin-left: 4px;
  font-size: 24px;
  font-weight: 500;
  line-height: 17px;
}

.login-module-wrap {
  width: 340px;
  border-radius: 5px;
  background-color: #fff;
}

.off-line-tip {
  margin-bottom: 10px;
  font-size: 15px;
  line-height: 30px;
}

.change-psw-btn {
  margin: 0 8px;
  color: #1a70db;
}

.off-line-btn {
  text-align: right;
}
</style>
